'use strict'
import request from '@/utils/request'
class HistorialchatService{
    static gethistorialchat(){
        return request({
            url:'/historialchat/gethistorialchat',
            method:'get',
        })
    }
    static seecontenthistorialchat(query){
        return request({
            url:'/historialchat/seecontenthistorialchat',
            method:'put',
            params:query
        })
    }
}
export default HistorialchatService